import BangUp from "../../src/utils/BangUp";
import GameLoader from "../../src/utils/GameLoader";
import Layer from "../../src/utils/Layer";
import Layout from "../../src/utils/Layout";
import ViewManager from "../../src/utils/ViewManager";
import DragonBonesAnimation from "../../src/views/DragonBonesAnimation";
import SceneView from "../../src/views/SceneView";
import BetModel from "../model/BetModel";
import GameModel from "../model/GameModel";
import SpinModel from "../model/SpinModel";
import { BounceZoomIn, FadeIn, FadeOut } from "../transitions/TransitionAnimations";
import { State } from "./State";
import { Ease } from "../Ease";
import { Tween } from "./../Tween";
import Locale, { LocaleId } from "../utils/Locale";
import BitmapTextField from "../views/components/BitmapTextField";
import TextField from "../views/components/TextField";
import App from "../App";
import KeyboardManager, { Key } from "../utils/KeyboardManager";
import { StateMachine } from "./StateMachine";
import SoundController from "../utils/SoundController";
import SoundVars from "../const/SoundVars";
import ISpinData from "../server/data/ISpinData";
import PointerEvents from "../const/PointerEvents";
import { Text } from "pixi.js";
import GambleModel from "../model/GambleModel";
import GameEvents from "../const/GameEvents";
import { Commands } from "../commands/CommandEnum";
import CommandManager from "../commands/CommandManager";

export default class GenericBigWinState extends State {
    protected layer: Layer;
    protected backgroundLayer: Layer;
    protected spinModelProp:  keyof ISpinData;
    protected bwBitmapText: BitmapTextField | TextField | Text;
    protected scene: SceneView;
    protected backgroundScene: SceneView;
    protected currentBigWinLevel = 0;
    protected maxBigWinLevel = 0;
    protected bigWinScenes = [
        "bigWin",
        "hugeWin",
        "masiveWin",
        "megaWin"
    ];
    protected bitWinTexts = [
        LocaleId.bigwin_title,
        LocaleId.hugewin_title,
        LocaleId.masive_Win,
        LocaleId.megawin_title
    ];

    protected bigWinsDelayConfig;

    // protected bangUp: BangUp;
    protected bangUpVal: number = 0;
    protected _canExit = false;
    protected currentBangup: BangUp;
    protected coinAnimation: DragonBonesAnimation;
    protected delayedCall:Tween;
    protected bigWinAnimDelayed: Tween;
    protected fade:Tween;
    protected bigWinAnimComplete: boolean = false;
    protected skipped: boolean;

    constructor(stateMachine: StateMachine, spinModelProp: keyof ISpinData = "winAmount"){
        super(stateMachine);
        this.spinModelProp = spinModelProp;
    }

    public enter(): void {
        this.skipped = false;
        this._canExit = false;
        this.bigWinAnimComplete = false;
        super.enter();
        this.bitWinTexts = GameModel.gameConfig.bitWinTexts ||  this.bitWinTexts;
        this.bigWinScenes = GameModel.gameConfig.bigWinScenes ||  this.bigWinScenes;
        if(GameModel.gameConfig.bigWinsDelayConfig) {
            this.bigWinsDelayConfig = GameModel.gameConfig.bigWinsDelayConfig;
        } else {
            this.bigWinsDelayConfig = this.bigWinScenes.reduce((obj, winName) => {
                obj[winName] = {
                    "bigWinDuration": GameModel.gameConfig.bigWinDuration || 3,
                    "bigWinBangupDuration": GameModel.gameConfig.bigWinBangupDuration || 2,
                    "bigWinPresent": GameModel.gameConfig.bigWinPresent || 1.5,
                    "bigWinEnd" : GameModel.gameConfig.bigWinEnd || 2
                }
                return obj;
            }, {})
        }

        this.setHighestWinLevel();
        this.layer = ViewManager.getLayer("WinSplash");
        this.backgroundLayer = ViewManager.getLayer("CelebrationBackground");
        KeyboardManager.onKey("pressed", Key.SPACE, this.skipWithKey, this);
        this.backgroundLayer.interactive = true;
        this.backgroundLayer.on(PointerEvents.DOWN, this.skipWithKey, this);
        this.layer.clear();
        this.scene = this.layer.setScene("win");
        this.startBigWin();
        if (GameModel.gameConfig.playBigWinCoins) {
            this.startCoinAnimation();
        }
    }

    protected startBigWin() {
        this.bigWinAnimComplete = false;
        this.backgroundScene = this.backgroundLayer.setScene(this.bigWinScenes[this.currentBigWinLevel]);
        this.bwBitmapText = this.scene.sceneTextFields.get("win");
        this.bwBitmapText ? this.bwBitmapText.text = Locale.getString(this.bitWinTexts[this.currentBigWinLevel]) : null;
        const winMoney = this.scene.sceneMoneyFields.get("win_counter");
        winMoney.value = this.bangUpVal;
        this.playTransitionSound();
        this.bwBitmapText ? this.fade = FadeIn(this.bwBitmapText, 0.5) : null;
        let bangupEndVal = this.getSum();
        this.currentBangup = new BangUp();
        let bigWinDuration = this.bigWinsDelayConfig[this.bigWinScenes[this.currentBigWinLevel]].bigWinDuration;
        let bigWinBangupDuration = this.bigWinsDelayConfig[this.bigWinScenes[this.currentBigWinLevel]].bigWinBangupDuration;

        this.bigWinAnimDelayed = Tween.delayedCall(bigWinDuration, this.onBigWinAnimationComplete, [], this);
        this.currentBangup.startBangup(this.bangUpVal, bangupEndVal, bigWinBangupDuration, {ease: Ease.None}, (val) => {
            this.bangUpVal = val;
            winMoney.value = this.bangUpVal;
        }, () => {
            this.onBigWinBangupComplete();
        });
        this._canExit = true;
    }

    playTransitionSound() {
        // SoundController.playSound(SoundVars.WIN_BIGWIN)
    }

    protected onBigWinBangupComplete():void {

    }

    protected onBigWinAnimationComplete() {
        let bigWinPresent = this.bigWinsDelayConfig[this.bigWinScenes[this.currentBigWinLevel]].bigWinPresent;
        let bigWinEnd = this.bigWinsDelayConfig[this.bigWinScenes[this.currentBigWinLevel]].bigWinEnd;

        if(!this.canExit()) {
            bigWinEnd = 1;
        }

        this.currentBigWinLevel++;
        if (this.fade) {
            this.fade.kill();
        }
        if (this.currentBigWinLevel <= this.maxBigWinLevel) {
            this.playCounterCompleteSound();
            this.bwBitmapText ? this.fade = FadeOut(this.bwBitmapText, bigWinPresent / 2, bigWinPresent / 2) : null;
            this.delayedCall = Tween.delayedCall(bigWinPresent, () => this.startBigWin());
        } else {
            this._canExit = false;
            if (GameModel.gameConfig.playBigWinCoins) {
                this.coinAnimation.stopOnComplete();
            }
            this.playCollectSound();
            if (this.bwBitmapText) {
                this.bwBitmapText.alpha = 1;
                this.bwBitmapText.text = Locale.getString(this.bitWinTexts[this.maxBigWinLevel]);
            }
            this.bangUpVal = this.getSum();
            const winMoney = this.scene.sceneMoneyFields.get("win_counter");
            winMoney.value = this.bangUpVal;
            this.bwBitmapText ? this.fade = FadeOut(this.bwBitmapText, bigWinEnd / 2, bigWinEnd / 2) : null;
            this.delayedCall = Tween.delayedCall(bigWinEnd, () => {
                this.onBigWinComplete()
            });
        }
        this.bigWinAnimComplete = true;
    }

    playCounterCompleteSound() {
        // SoundController.playSound(SoundVars.WIN_BIGWIN)
    }

    playCollectSound() {
        SoundController.playSound(SoundVars.BIG_WIN_COMPLETE)
    }

    protected onBigWinComplete() {
        this._canExit = false;
        if (this.coinAnimation) {
            this.coinAnimation.destroy();
            this.coinAnimation = null;
        }
        this.scene = null;
        this.currentBigWinLevel = 0;
        this.maxBigWinLevel = 0;
        this.bangUpVal = 0;
        this.layer.completeClear();
        this.backgroundLayer.off(PointerEvents.DOWN, this.skipWithKey, this);
        this.backgroundLayer.completeClear();
        KeyboardManager.offKey("pressed", Key.SPACE, this.skipWithKey , this);
        App.dispatcher.emit(GameEvents.SHOW_BIG_WIN_COMPLETE);
        CommandManager.execute(Commands.UPDATE_WIN);
        this.exit();
    }

    protected getSum():number {
        let bangupEndVal = 0;
        if (this.maxBigWinLevel > this.currentBigWinLevel) {
            bangupEndVal = GameModel.gameConfig.bigWinRatioLevels[this.currentBigWinLevel] * BetModel.totalBet;
        } else {
            bangupEndVal = SpinModel[this.spinModelProp];
        }
        return bangupEndVal;
    }

    protected setHighestWinLevel() {
        const bigWinRatios = GameModel.gameConfig.bigWinRatioLevels;
        const currentWinRatio = SpinModel.getWinRatio();
        for (let i = bigWinRatios.length - 1; i > 0; i--) {
            if (bigWinRatios[i] <= currentWinRatio) {
                this.maxBigWinLevel = i;
                break;
            }
        }
    }

    protected startCoinAnimation() {

        // TODO add mask
        const resources = GameLoader.loader.resources;
        this.coinAnimation = new DragonBonesAnimation("Generic_coin_animation",
            resources.dbCoinsData.data,
            resources.dbCoinsTextures.data,
            resources.dbCoinsImage.texture);
        this.scene.addChild(this.coinAnimation.displayObject);

        this.coinAnimation.play("Coin_animation_full", 600);

        let positionCoins = () => {
            let bounds = this.scene.shapes.get("coins");
            this.coinAnimation.displayObject.x = bounds.width * 0.5 * bounds.parent.scale.x;
            this.coinAnimation.displayObject.y =  bounds.height * bounds.parent.scale.y;
            this.coinAnimation.displayObject.scale.x = Layout.globalScale;
            this.coinAnimation.displayObject.scale.y = Layout.globalScale;
        }
        this.coinAnimation.play("Coin_animation_full", 600);
        positionCoins();
        this.scene.orientationChangeCallback  = this.scene.rescaleChangeCallback = (() => {
            positionCoins();
        }).bind(this);
    };

    canExit() {
        return this._canExit;
    }

    skipWithKey(){
        if (this.canExit()) {
            this.skip();
        }
    }

    skip() {
        App.dispatcher.emit(GameEvents.BIG_WIN_SKIPPED);
        this.skipped = true;
        this.backgroundLayer.off(PointerEvents.DOWN, this.skipWithKey, this);
        KeyboardManager.offKey("pressed", Key.SPACE, this.skipWithKey , this);
        this._canExit = false;
        if(this.delayedCall ) {
            this.delayedCall.kill();
        }
        this.currentBigWinLevel = this.maxBigWinLevel;
        this.currentBangup.clearBangup();
        if(this.bigWinAnimComplete && !GambleModel.gambleButtonClicked) {
            this.onBigWinAnimationComplete();
        }
    }

}
